import { a as c } from "./chunk-BaseElement-BuXbltG-.js";
import "./chunk-lit-element-CNHURX5C.js";
import { e as l } from "./chunk-query-pk3khlGb.js";
var w = Object.defineProperty, h = (o, i, e, s) => {
  for (var r = void 0, n = o.length - 1, a; n >= 0; n--)
    (a = o[n]) && (r = a(i, e, r) || r);
  return r && w(i, e, r), r;
}, t;
const p = (t = class extends c {
  async _loadAndCheckSwiper() {
    (async () => await import("./chunk-swiper-element-bundle-Bk-3iR66.js").then((i) => {
      const { register: e } = i;
      e();
    }))();
    try {
      return window.customElements.get(t.SWIPE_ELEMENT_TO_CHECK) ? this._initializeSwiper() : (await window.customElements.whenDefined(
        t.SWIPE_ELEMENT_TO_CHECK
      ), this._initializeSwiper());
    } catch (i) {
      console.error("Error loading Swiper:", i);
    }
  }
  get swiperInstance() {
    return this.swiperContainer.swiper;
  }
  _initializeSwiper() {
    if (!this.swiperContainer) return console.error("No swiper container found");
    const i = this.swiperContainer;
    this.swiperOptions = {
      cssMode: !0,
      init: !1,
      lazyPreloadPrevNext: 1,
      ...this.swiperOptions
    }, this.swiperOptions.on || (this.swiperOptions.on = {});
    const e = this.swiperOptions.on.afterInit;
    if (this.swiperOptions.on.afterInit = (s) => {
      typeof e == "function" && e(s), this.fixNavigationAccessibility(s);
    }, i.tagName !== t.SWIPE_ELEMENT_TO_CHECK.toUpperCase())
      return console.error("Invalid swiper container");
    Object.assign(i, this.swiperOptions || {}), i.initialize();
  }
  fixNavigationAccessibility(i) {
    this.id && i.navigation.nextEl && i.navigation.prevEl && (i.navigation.nextEl.setAttribute("aria-controls", this.id), i.navigation.prevEl.setAttribute("aria-controls", this.id));
  }
  firstUpdated(i) {
    super.firstUpdated(i), this.setUpObservers();
  }
  // Refresh swiper
  refreshSwiper() {
    var i;
    return (i = this.swiperInstance) == null ? void 0 : i.update();
  }
  // Reinitialize swiper
  reInitialize() {
    var i;
    (i = this.swiperInstance) == null || i.destroy(!0, !0), this._initializeSwiper();
  }
  setUpObservers() {
    const i = {
      root: null,
      threshold: 0.1
    }, e = new IntersectionObserver((s) => {
      s.forEach((r) => {
        r.isIntersecting && (this._loadAndCheckSwiper(), e.disconnect());
      });
    }, i);
    e.observe(this);
  }
}, t.SWIPE_ELEMENT_TO_CHECK = "swiper-container", t);
h([
  l("swiper-container")
], p.prototype, "swiperContainer");
let u = p;
export {
  u as S
};
